import AuthService from "../auth/auth_service";

export default class GroupService extends AuthService {
  constructor() {
    super("group-service")
  }
}
